import { CircleAlert } from 'lucide-react'

import { Button } from '@/components/atoms/Button'
import { useScopedI18n } from '@/locales/client'

type Props = {
  reset: () => void
}

export default function ErrorPage({ reset }: Props) {
  const t = useScopedI18n('dialogs.partDetails')
  return (
    <div className="grid size-full min-h-screen place-items-center">
      <section className="flex flex-col items-center" role="alert" aria-live="assertive">
        <CircleAlert className="mb-1 size-8 text-rsf-red" aria-hidden="true" />
        <h4 className="mb-2 text-lg text-rsf-black">{t('error.title')}</h4>
        <p className="mb-6 text-pretty break-words text-center leading-snug text-rsf-grey-dark">
          {t('error.description')}
        </p>
        <div className="flex flex-row gap-2">
          <Button variant="outline" className="bg-transparent" asChild>
            <a href="https://g1.redseafish.com/support/" target="_blank" rel="noreferrer noopener">
              {t('error.contact')}
            </a>
          </Button>

          <Button onClick={() => reset()}>
            {t('error.retry')}
          </Button>
        </div>
      </section>
    </div>
  )
}
